import { useEffect, useState} from "react";
import {
  InputState,
  initialState,
  RatesType,
  Mapping,
  multiplier,
  mult,
  AnnualDirectorData,
  DirRates

} from "./variables";
import {
  OutputTable
} from "./table";
import {
  Select,
  TextField,
  Paper,
  FormControl,
  MenuItem,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Box,


  
} from "@mui/material";
import "../App.css";


export const perc = (original:number):string=>{
  return (original*100).toFixed(2)+"%"
}

export const NationalInsurance = (): JSX.Element => {
  const [inputState, setInputState] = useState<InputState>(initialState);
 
  const [director,setDirector] = useState<boolean>(false);

  useEffect(() => {

    let url = document.URL
    if (url.indexOf("?")!==-1) {
    let paramString = document.URL.split('?')[1];
let params_arr = paramString.split('&');

for (let i = 0; i < params_arr.length; i++) {
   let pair = params_arr[i].split('=');
   if (pair[0] === "type") {
    if (pair[1]==="director") {
      setDirector(true)
      inputState.employmentType="director"
      setInputState(inputState)
    } else {
      setDirector(false)
      inputState.employmentType="employee"
      setInputState(inputState)
    }
   }
  }
}
  
  


  },[]);

  
  const dir = "row"
  
  return (
    <Paper
      className="myinput"
      style={{
        width: "90%",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        marginTop: "20px",
        background: "#F2F2F7",
      }}
    >
      {/* //"#F2F2F7" */}
      

    <Box style={{display:"flex",flexDirection:dir,justifyContent:"flex-start","width":"99%"}}>
  
      <TextField
        label="Gross pay"
        size="small"
        type="number"
        
        style={{marginTop: "15px", background: "white","width":"99%",marginLeft:"2px"}}
        InputLabelProps={{
          shrink: true,
          style: {color: "black", fontWeight: "bold"},
        }}
        InputProps={{
          startAdornment: <InputAdornment position="start">£</InputAdornment>,
          inputProps: {min: 0,step:"0.01"},
        
          
          
          
        }}
        onChange={e => {          
          inputState.pay = parseFloat(e.target.value);
          setInputState({...inputState});
        }}
        value={inputState.pay}
      />
      <FormControl size="small" style={{marginTop: "16px",marginLeft:"10px",width:"99%"}}>
        <InputLabel size="small" style={{fontWeight: "bold", color: "black"}}>
          Per
        </InputLabel>
        <Select
          size="small"
          label="Per"
          style={{background: "white","width":"99%"}}
          value={inputState.payPeriod}
          input={<OutlinedInput label="Per" />}
          onChange={e => {
            inputState.payPeriod = e.target.value as string;
            setInputState({...inputState});
          }}
        >
          <MenuItem value="annually">Year</MenuItem>
          <MenuItem value="monthly">Month</MenuItem>
          <MenuItem value="weekly">Week</MenuItem>
          <MenuItem value="daily">Day</MenuItem>
        </Select>
      </FormControl>
      <FormControl style={{marginTop: "15px","width":"99%",marginLeft:"10px"}}>
        <InputLabel style={{color: "black", fontWeight: "bold",marginLeft:"0px"}}>
          Select NICs Category
        </InputLabel>
        <Select
        size="small"
          inputProps={{}}
          input={<OutlinedInput label="Select NICs Category" style={{marginLeft:"10px"}} />}
          value={inputState.category}
          style={{background: "white","width":"99%"}}
          onChange={e => {
            inputState.category = e.target.value;
            setInputState({...inputState});
          }}
        >
          <MenuItem value="A">A</MenuItem>
          <MenuItem value="B">B</MenuItem>
          <MenuItem value="C">C</MenuItem>
          <MenuItem value="F">F</MenuItem>
          <MenuItem value="H">H</MenuItem>
          <MenuItem value="I">I</MenuItem>
          <MenuItem value="J">J</MenuItem>
          <MenuItem value="L">L</MenuItem>
          <MenuItem value="M">M</MenuItem>
          <MenuItem value="S">S</MenuItem>
          <MenuItem value="V">V</MenuItem>
          <MenuItem value="Z">Z</MenuItem>
        </Select>
      </FormControl>
     
     
      </Box>
      
      {/* <Box style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
       <Box style={{textAlign:"center",width:"99%",marginTop:"20px"}}>       
      <FormLabel style={{ color: "black",marginLeft:"10px",textDecoration:"none"}}>
      Company Director
        </FormLabel>
        <Switch
          onChange={e => {
            
            setDirector(!director)
                      
          }}
          checked={director}
          value={director}
        />
        </Box>

        </Box> */}
      
      <Box style={{display:"flex",flexDirection:dir,justifyContent:"flex-start","width":"99%",marginLeft:"0px"}}>
      <FormControl size="small" style={{marginTop: "15px","width":director?"99%":"33%",marginLeft:"2px"}}>
        <InputLabel style={{color: "black", fontWeight: "bold"}}>
          Employment type
        </InputLabel>
        <Select
        size="small"
          inputProps={{}}
          input={<OutlinedInput label="Employment Type" style={{marginLeft:"10px"}} />}
          value={inputState.employmentType}
          style={{background: "white","width":"99%"}}
          onChange={e => {
            inputState.employmentType = e.target.value;
            if (inputState.employmentType=="employee") {
              setDirector(false)
            } else {
              setDirector(true)
            }
            setInputState({...inputState});
          }}
        >
          <MenuItem value="director">Director</MenuItem>
          <MenuItem value="employee">Employee</MenuItem>
        
        </Select>
      </FormControl>

<FormControl 
  size="small" 
  style={{
    marginTop: "15px",
    width: "33%",
    marginLeft: "2px",
    display: director ? "none" : "inline"
  }}
>
  <InputLabel style={{color: "black", fontWeight: "bold"}}>
    Tax Year
  </InputLabel>
  <Select
    size="small"
    input={<OutlinedInput label="Tax Year" />}
    value={inputState.selectedTaxYear}
    style={{background: "white", width: "99%"}}
    onChange={e => {
      inputState.selectedTaxYear = e.target.value;
      setInputState({...inputState});
    }}
  >
    <MenuItem value="firstPeriod">2021-22</MenuItem>
    <MenuItem value="secondPeriod">2022-23</MenuItem>
    <MenuItem value="thirdPeriod">2023-24</MenuItem>
    <MenuItem value="fourthPeriod">2024-25</MenuItem>
    <MenuItem value="fifthPeriod">2025-26</MenuItem>
    <MenuItem value="sixthPeriod">2026-27</MenuItem>
  </Select>
</FormControl>

<FormControl 
  size="small" 
  style={{
    marginTop: "15px",
    width: "33%",
    marginLeft: "2px",
    display: director ? "none" : "inline"
  }}
>
  <InputLabel style={{color: "black", fontWeight: "bold"}}>
    Compare with
  </InputLabel>
  <Select
    size="small"
    input={<OutlinedInput label="Compare with" />}
    value={inputState.comparisonTaxYear || ""}
    style={{background: "white", width: "99%"}}
    onChange={e => {
      inputState.comparisonTaxYear = e.target.value || null;
      setInputState({...inputState});
    }}
  >
    <MenuItem value="">None</MenuItem>
    <MenuItem value="firstPeriod">2021-22</MenuItem>
    <MenuItem value="secondPeriod">2022-23</MenuItem>
    <MenuItem value="thirdPeriod">2023-24</MenuItem>
    <MenuItem value="fourthPeriod">2024-25</MenuItem>
    <MenuItem value="fifthPeriod">2025-26</MenuItem>
    <MenuItem value="sixthPeriod">2026-27</MenuItem>
  </Select>
</FormControl>
        
        <TextField
         
         type="date"
         size="small"
         label="Directorship Start Date"
         onChange={(e)=>{
               
          const oneJan = new Date(2023,3,6);
          const endTax = new Date(2024,3,5)
       
          const date = new Date(Math.max(new Date(e.target.value).getTime(),oneJan.getTime()))
          
          const  numberOfDays = Math.floor((date.getTime() - oneJan.getTime()) / (24 * 60 * 60 * 1000));
          const result = Math.round(( date.getDay() + 1 + numberOfDays) / 7)
  
          inputState.directorshipStart = e.target.value
          inputState.proRataThreshold = Math.max((53-result)/52,0)
          if (date.getTime()<=oneJan.getTime())
            inputState.firstPaidMonth = 0
          else if (date.getTime()>=endTax.getTime())
            inputState.firstPaidMonth = 13
          else 
            inputState.firstPaidMonth = date.getMonth()-3>=0? date.getMonth()-3:date.getMonth()+9
          
          setInputState({...inputState})
         }}
         value={inputState.directorshipStart}
         style={{display:director?"flex":"none" ,marginTop: "15px", background: "white","width":"99%",marginLeft:"10px"}}
         InputLabelProps={{
          shrink: true,
          style: {color: "black", fontWeight: "bold"},
        }}
        >
          </TextField>
          
          <FormControl size="small" style={{display:director?"inline":"none",marginTop:"15px",width:"99%",marginLeft:"10px"}} >
        <InputLabel style={{color: "black", fontWeight: "bold",marginLeft:"0px"}} >
          Calculation method
        </InputLabel>
        <Select
        disabled={!director}
        size="small"
          inputProps={{}}
          input={<OutlinedInput label="Select NICs Category" style={{marginLeft:"10px"}} />}
          value={inputState.calculationType}
          style={{background: "white","width":"99%"}}
          onChange={e => {
            inputState.calculationType = e.target.value;
            setInputState({...inputState});
          }}
        >
          <MenuItem value="standard">Regular</MenuItem>
          <MenuItem value="alternative">Alternative</MenuItem>
          
          {/* <MenuItem value="alternative">Alternative</MenuItem> */}
          
        </Select>
      </FormControl>

      
      </Box>
      
      

      
        {/* <Fade in={director} unmountOnExit> */}
        <Box style={{display:"flex",flexDirection:"row",marginTop:"20px"}}>       
          <OutputTable 
            firstPeriodPaid={inputState.firstPaidMonth}  
            proRata={inputState.proRataThreshold} 
            director={director} 
            pay={inputState.pay * multiplier[inputState.payPeriod as keyof mult]} 
            calculationType={inputState.calculationType} 
            category={inputState.category}
            selectedTaxYear={inputState.selectedTaxYear}
            comparisonTaxYear={inputState.comparisonTaxYear}
          />
        </Box>
        {/* </Fade> */}
      
        
   
    
    </Paper>
  );
};
export const currencyFormat = (num: number): string => {
  const absNum = Math.abs(num);
  const formattedNum = "£" + absNum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  return num < 0 ? "-" + formattedNum : formattedNum;
};

export const roundUpAll = (original: number): number => {
  const tempOr = original.toString();

  let value;
  if (tempOr.indexOf(".") === -1) return original;
  else {
    value = tempOr + "00";
  }
  let up = false;
  for (let i = value.indexOf(".") + 3; i < value.length; i++) {
    const d = value.charAt(i);
    if (d !== "0") {
      up = true;
      break;
    }
  }
  const digits = value.split(".")[1];
  if (up && digits[1] === "9" && digits[0] === "9") {
    return Math.round(original);
  } else if (up && digits[1] === "9") {
    return parseFloat(value.split(".")[0] + "." + (parseInt(digits[0]) + 1).toString());
  } else if (up) {
    return parseFloat(value.split(".")[0] +"." + digits[0] +  (parseInt(digits[1]) + 1).toString());
  } else {
    return original;
  }
};
export const calculateNI = (
  pay: number,
  category: string,
  rates: RatesType,
  isEmployer: boolean,
  month: string,
  taxYear: string
): number => {
  const period = rates[taxYear as keyof RatesType];
  if (!period) return 0;

  let total = 0;
  for (const band of period) {
    const contribution = band.categories[category as keyof Mapping];
    const eligible = Math.min(Math.max(pay - band.start, 0), band.end - band.start);
    total += eligible * contribution;
  }
  return total;
};
export const calculateAnnualDirectorEmployeeNic = (pay:number,rates:AnnualDirectorData,proRata:number) => {
  let employee_amount = 0;
  
  let totPay = pay;

  for (let i=0;i < 7;i++) {
    const res = calculateDirectorNic(totPay,rates,"first_period",employee_amount,proRata)
    employee_amount+=res
    
    totPay+=pay
  }
  for (let i=0;i < 5;i++) {
    const res = calculateDirectorNic(totPay,rates,"second_period",employee_amount,proRata)
    employee_amount+=res    
    totPay+=pay
  }
  return employee_amount
}
export const calculateDirectorNic = (totPay:number, rates:AnnualDirectorData,period:string,totPaid:number,proRata:number) => {

  const between_pay_uel = Math.max(totPay-rates.upper_earning_limit*proRata,0)
  const between_pay_pt =  Math.max(totPay-rates.primary_threshold*proRata - between_pay_uel,0)  

  let employee_amount = between_pay_uel * rates["rates"][period as keyof DirRates].upper_earning_limit + between_pay_pt *  rates["rates"][period as keyof DirRates].primary_threshold  

  
  return (employee_amount-totPaid);

}




export const calculateAnnualCompanyNic = (totPay:number,rates:AnnualDirectorData,proRata:number) => {

  const between_pay_st = Math.max((totPay - rates.secondary_threshold*proRata),0) * rates.rates.second_period.secondary_threshold   
  return between_pay_st
}

export const calculateCompanyDirNic = (totPay:number, rates:AnnualDirectorData,period:string,totPaid:number,proRata:number) => {
  const between_pay_st = Math.max((totPay - rates.secondary_threshold*proRata),0) 

  
  let comp_amount = between_pay_st * rates.rates[period as keyof DirRates].secondary_threshold   
  return (comp_amount - totPaid)


}
